import React from 'react';
import "./DownloadPage.scss";
import DownloadSvgComponent from '../../../Images/DownloadSvgComponent';
import InstallSvgComponent from '../../../Images/InstallSvgComponent';

const DownloadPage = () => {
  return (
  <div className="download__">
    <div className='download__logocontainer'>

    </div>
    <div className="download__page">
      <div className="download__page-heading">
      Launch your Infogenesis App Installer once it gets downloaded
      </div>
      <div className="download__page-container">
        <div className="download__page-container-download">
          <div className="download-image-container">
          <DownloadSvgComponent className='download-image'/>
          </div>
          <div className="download-heading">
          Download has started. Launch App once download gets completed
          </div>
        </div>
        <div className="download__page-container-line"></div>
        <div className="download__page-container-install">
          <div className="install-image-container">
          <InstallSvgComponent className='install-image'/>
          </div>
          <div className="install-heading">
          Finish Installation
          </div>
          <div className="install-description">
          Open your downloads folder and locate the IG App installer file to start installation process.
          </div>
        </div>
      </div>
    </div>
  </div>
  )
}

export default DownloadPage;